<div dropdown class="dropdown" [isDisabled]="1 | isReadonlyRole">
  <button dropdownToggle type="button" class="dropdown-toggle" [class.caret-none]="!btnLabel" [ngClass]="btnClass">
    <span class="cs-icon cs-icon-bolt"></span> {{ btnLabel }}
  </button>
  <ul *dropdownMenu class="dropdown-menu" [class.dropdown-menu-right]="dropdownRight">
    <li
      *ngIf="isAnyImportedFromABBV2"
      i18n-matTooltip
      matTooltip="Re-import selected bookings from Airbnb."
      matTooltipPosition="left"
    >
      <button (click)="onImport()" type="button">
        <i class="cs-icon fa-fw cs-icon-download"></i> <ng-container i18n>Re-import</ng-container>
      </button>
    </li>
    <!-- Link -->
    <li
      i18n-matTooltip
      matTooltip="Link multiple related inquiries together. This allows them to share the same data."
      matTooltipPosition="left"
    >
      <button (click)="onLink()" type="button">
        <i class="far fa-fw fa-link"></i> <ng-container i18n>Link</ng-container>
      </button>
    </li>

    <li class="dropdown-divider"></li>

    <!-- Paid -->
    <li *ngIf="isAnyUnpaid" i18n-matTooltip matTooltip="Mark selected bookings as paid." matTooltipPosition="left">
      <button (click)="onPaid()" type="button">
        <i class="far fa-fw fa-money-check-alt"></i> <ng-container i18n>Mark as Paid</ng-container>
      </button>
    </li>

    <!-- Unpaid -->
    <li *ngIf="!isAnyUnpaid" i18n-matTooltip matTooltip="Mark selected bookings as unpaid." matTooltipPosition="left">
      <button (click)="onUnpaid()" type="button">
        <i class="far fa-fw fa-money-check-alt"></i> <ng-container i18n>Mark as Unpaid</ng-container>
      </button>
    </li>

    <!-- In-House -->
    <li
      *ngIf="isAnyNotInhouse"
      i18n-matTooltip
      matTooltip="Mark selected bookings as in-house. Only booked reservations that have reached their check-in date are eligible."
      matTooltipPosition="left"
    >
      <button (click)="onInhouse()" type="button">
        <i class="far fa-fw fa-home"></i> <ng-container i18n>Mark as In-House</ng-container>
      </button>
    </li>

    <!-- Not In-House -->
    <li
      *ngIf="isAnyInhouse"
      i18n-matTooltip
      matTooltip="Remove the in-house status from selected bookings."
      matTooltipPosition="left"
    >
      <button (click)="onNoInhouse()" type="button">
        <i class="far fa-fw fa-home"></i> <ng-container i18n>Mark as Not In-House</ng-container>
      </button>
    </li>

    <!-- Mark for followup -->
    <li
      *ngIf="isAnyNoFollow"
      i18n-matTooltip
      matTooltip="Flag selected inquiries for follow-up later."
      matTooltipPosition="left"
    >
      <button (click)="onFollowUp()" type="button">
        <i class="far fa-fw fa-star"></i> <ng-container i18n>Mark for Follow Up</ng-container>
      </button>
    </li>

    <!-- Mark for no followup -->
    <li
      *ngIf="!isAnyNoFollow"
      i18n-matTooltip
      matTooltip="Remove follow-up flag from selected inquiries."
      matTooltipPosition="left"
    >
      <button (click)="onNoFollowUp()" type="button">
        <i class="far fa-fw fa-star"></i> <ng-container i18n>Mark for No Follow Up</ng-container>
      </button>
    </li>

    <!-- Mark as read -->
    <li *ngIf="isAnyUnRead" i18n-matTooltip matTooltip="Mark selected inquiries as read." matTooltipPosition="left">
      <button (click)="onRead()" type="button">
        <i class="far fa-fw fa-envelope-open"></i> <ng-container i18n>Mark as Read</ng-container>
      </button>
    </li>

    <!-- Mark as unread -->
    <li *ngIf="!isAnyUnRead" i18n-matTooltip matTooltip="Mark selected inquiries as unread." matTooltipPosition="left">
      <button (click)="onUnRead()" type="button">
        <i class="far fa-fw fa-envelope"></i> <ng-container i18n>Mark as Unread</ng-container>
      </button>
    </li>

    <li class="dropdown-divider"></li>

    <!-- Add tags -->
    <li i18n-matTooltip matTooltip="Add tags to selected inquiries" matTooltipPosition="left">
      <button (click)="onAddTags()" type="button">
        <i class="far fa-fw fa-tags"></i> <ng-container i18n>Add Tags</ng-container>
      </button>
    </li>

    <li class="dropdown-divider"></li>

    <!-- Download -->
    <li *ngIf="dataSource?.filteredData?.length === 0">
      <button
        i18n-matTooltip
        matTooltip="There are no inquiries under current filter"
        matTooltipPosition="left"
        type="button"
        class="tone-down"
      >
        <i class="cs-icon cs-icon-download"></i> <ng-container i18n>Download</ng-container>
      </button>
    </li>
    <li *ngIf="dataSource?.filteredData?.length !== 0">
      <button
        (click)="onDownload()"
        type="button"
        i18n-matTooltip
        matTooltip="Download your inquiries to csv"
        matTooltipPosition="right"
      >
        <i class="cs-icon cs-icon-download"></i> <ng-container i18n>Download</ng-container>
      </button>
    </li>

    <!-- Export Report -->
    <li>
      <button
        (click)="onExportReport()"
        type="button"
        i18n-matTooltip
        matTooltip="Export the inquiries for selected year and rental(s)"
        matTooltipPosition="right"
      >
        <i class="fal fa-download"></i> <ng-container i18n>Export Report</ng-container>
      </button>
    </li>

    <!-- Import from CSV -->
    <li>
      <button
        (click)="onImportCSV()"
        type="button"
        [disabled]="1 | isReadonlyRole"
        i18n-matTooltip
        matTooltip="Import multiple inquiries at a time"
        matTooltipPosition="right"
      >
        <i class="cs-icon cs-icon-upload"></i> <ng-container i18n>Import from CSV</ng-container>
      </button>
    </li>

    <li class="dropdown-divider"></li>

    <!-- Archive -->
    <li
      *ngIf="isAnyUnArchived"
      i18n-matTooltip
      matTooltip="Archive inquiries after completing any required actions on their originating channels."
      matTooltipPosition="left"
    >
      <button (click)="onArchive()" type="button">
        <i class="far fa-fw fa-archive"></i> <ng-container i18n>Archive</ng-container>
      </button>
    </li>

    <!-- Unarchive -->
    <li
      *ngIf="!isAnyUnArchived"
      i18n-matTooltip
      matTooltip="Unarchive previously archived inquiries."
      matTooltipPosition="left"
    >
      <button (click)="onUnArchive()" type="button">
        <i class="far fa-fw fa-file-archive"></i> <ng-container i18n>Unarchive</ng-container>
      </button>
    </li>

    <!-- Delete -->
    <li i18n-matTooltip matTooltip="Delete selected inquiries and bookings." matTooltipPosition="left">
      <button (click)="onDelete()" type="button">
        <i class="cs-icon fa-fw cs-icon-trash"></i> <ng-container i18n>Delete</ng-container>
      </button>
    </li>
  </ul>
</div>
